import React from 'react';
import { toast } from 'react-toastify';
import Button from '~/modules/components/global/button';

const DEFAULT_TOAST_OPTIONS = {
	theme: 'dark', pauseOnHover: true, hideProgressBar: false, closeOnClick: true
};
const ToastService = {
	create(type, message, options) {
		const allOptions = { ...DEFAULT_TOAST_OPTIONS, ...options };
		// TODO: Verify all type's match
		// TODO: Find all calls and modify options
		return toast[type](message, allOptions);
	},

	createWithAction(type, message, action, actionCb, options) {
		const allOptions = { ...DEFAULT_TOAST_OPTIONS, ...options };
		let content = <div>
			{message}
			<br/>
			<Button variant="primary" onClick={actionCb} style={{ float: 'inline-end', marginTop: 8 }}>{action}</Button>
		</div>;
		return toast[type](content, allOptions);
	},

	/**
	 * A toast carrying more than one choice.
	 *
	 * `closeOnClick` is off by default here: the handler it installs covers the
	 * whole toast, so with it on, reaching for one of these buttons dismisses the
	 * toast before the click lands on it. Each action closes the toast itself
	 * once it has run.
	 *
	 * @param {string} type react-toastify method — success, error, info, warning
	 * @param {string|element} message
	 * @param {array} actions [{ label, onClick, variant, testId }]
	 * @param {object} options react-toastify options
	 */
	createWithActions(type, message, actions = [], options) {
		const allOptions = { ...DEFAULT_TOAST_OPTIONS, closeOnClick: false, ...options };

		// A function rather than an element so react-toastify hands us the
		// dismisser for this particular toast.
		const content = ({ closeToast }) => (
			// A toast is a fixed 320px and clips what does not fit. Buttons carry
			// white-space: nowrap, so two of them side by side can be wider than
			// that — and a flex row that cannot wrap answers with its widest
			// possible line, stretching the content box. The message then wraps to
			// that phantom width and gets cut off mid-sentence along with the
			// button, which is what it looked like: text running under the
			// scrollbar. Wrapping keeps the row's demand down to its widest single
			// button; minWidth holds the rest to the toast.
			<div style={{ minWidth: 0, overflowWrap: 'anywhere' }}>
				{message}

				<div
					style={{
						display: 'flex',
						flexWrap: 'wrap',
						gap: 8,
						justifyContent: 'flex-end',
						marginTop: 12
					}}
				>
					{actions.map(({ label, onClick, variant = 'secondary', testId }) => (
						<Button
							key={label}
							variant={variant}
							size="sm"
							lighten
							data-testid={testId}
							onClick={() => {
								onClick?.();
								closeToast?.();
							}}
						>
							{label}
						</Button>
					))}
				</div>
			</div>
		);

		return toast[type](content, allOptions);
	},

	dismiss(toastId) {
		toast.dismiss(toastId);
	}
};

export default ToastService;
